export default __webpack_public_path__ + "static/media/car.769d507e.svg";